import { Refresh2 } from "iconsax-reactjs"

import { Button } from "@/components/ui/button"

interface ErrorBoundaryProps {
  error?: Error
}

export const ErrorBoundary = ({ error }: ErrorBoundaryProps) => {
  const isChunkLoadError = error?.message?.includes("dynamically imported module")

  const handleReload = () => {
    window.location.reload()
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] w-full bg-white px-6 text-center font-sans">
      <div className="w-full max-w-sm flex flex-col items-center">
        <div className="w-24 h-24 mb-6 rounded-full bg-gray-50 flex items-center justify-center">
          <Refresh2 size={48} className="text-primary-800 animate-spin-slow" variant="Bulk" />
        </div>

        <h1 className="text-xl font-bold text-gray-900 mb-3">
          {isChunkLoadError ? "Đã có bản cập nhật mới" : "Đã xảy ra lỗi"}
        </h1>

        <p className="text-gray-500 mb-8 text-sm leading-relaxed">
          {isChunkLoadError
            ? "Ứng dụng vừa được cập nhật các tính năng mới tối ưu hơn. Vui lòng tải lại để trải nghiệm ngay."
            : "Rất tiếc, đã xảy ra lỗi không mong muốn trong quá trình xử lý. Vui lòng thử lại sau giây lát."}
        </p>

        <Button
          onClick={handleReload}
          className="bg-primary-800 hover:bg-primary-900 text-white w-full max-w-[200px] rounded-xl h-12 font-semibold text-base shadow-lg shadow-primary-800/20 transition-all active:scale-95"
        >
          {isChunkLoadError ? "Cập nhật ngay" : "Tải lại trang"}
        </Button>

        {/* Dev only */}
        {!isChunkLoadError && import.meta.env.MODE === "development" && (
          <div className="mt-12 w-full p-4 bg-red-50 rounded-xl border border-red-100 overflow-hidden">
            <p className="text-red-800 text-xs font-bold mb-2 uppercase tracking-wider">
              Error Details (Dev Only)
            </p>
            <pre className="text-left text-xs text-red-600 overflow-auto whitespace-pre-wrap break-all max-h-32 font-mono">
              {error?.message || JSON.stringify(error)}
            </pre>
          </div>
        )}
      </div>
    </div>
  )
}
